// AUTO-GENERATED by scripts/fetch-cms-content.mjs (CMS flag tag_manager → locales).
// Gitignored — do NOT edit or commit.
/* eslint-disable */
export const CMS_TAG_MANAGER_LOCALES: string[] = [];
